import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';

import { isLoading } from 'hooks/requests';
import { Modal, Button, CircleLoading, EmailAccordion } from 'shared';
import { useInventoryService } from 'store/services/inventory.service';

const EmailSourceModal = ({ emailId, showEmailSourceModal, setShowEmailSourceModal }) => {
    const companyData = useSelector((state) => state.company.data);
    const { getEmailById } = useInventoryService();
    const [emails, setEmails] = useState(null);

    useEffect(() => {
        if (companyData) {
            if (emailId) {
                getEmailById(companyData?.id, emailId)
                    .then((res) => {
                        setEmails(res.data);
                    })
                    .catch((err) => {
                        console.error('Error fetching email by ID:', err);
                    });
            } else {
            }
        }
    }, [companyData, emailId]);

    return (
        <Modal
            fullWidth
            open={showEmailSourceModal}
            title="Email Source"
            handleClose={() => setShowEmailSourceModal(false)}
            customWidth="75%"
            showFooter
            footer={
                <Box>
                    <Button text="Close" onClick={() => setShowEmailSourceModal(false)} />
                </Box>
            }
        >
            {!emails ? (
                <CircleLoading />
            ) : !emails?.length ? (
                <Typography align="center">No email data found</Typography>
            ) : (
                <EmailAccordion emails={emails} />
            )}
        </Modal>
    );
};

export default EmailSourceModal;
